export const evaluateGet = "/sys/goods-evaluation";//获取列表
export const evaluateDetails = (id) => {return "/sys/goods-evaluation/" + id};//查看详情
export const evaluateDelete = (id) => {return "/sys/goods-evaluation/" + id + "/Delete"};//删除
